import React, { useContext } from "react";
import { useLocation, Link } from "react-router-dom";

import Avatar from "@mui/material/Avatar";

//icons
import { ReactComponent as OutlineFacebook } from "assets/icons/outlineIcons/outline-facebook.svg";
import { ReactComponent as OutlineInstagram } from "assets/icons/outlineIcons/outline-instagram.svg";
import { ReactComponent as OutlineTwitter } from "assets/icons/outlineIcons/outline-twitter.svg";
import { ReactComponent as OutlineLn } from "assets/icons/outlineIcons/outline-ln.svg";

// userContext import
import { CurrentUserContext } from "context/UserContext";

const Menu = ({ statusHandler }) => {
  const [menuActive, setMenuActive] = statusHandler;
  const location = useLocation().pathname;

  const menuStatus = menuActive ? "menu--active" : "menu--inactive";

  const [userContextData, setUserContextData] = useContext(CurrentUserContext);
  const userType = userContextData.admin;

  const handleSessionClose = () => {
    setUserContextData({
      // username: "",
      isLoggedIn: false,
    });
    setMenuActive(false);
  };

  const handleMenuClose = () => {
    setMenuActive(false);
  };

  return (
    <div className={`menu ${menuStatus}`}>
      <span
        onClick={() => setMenuActive(!menuActive)}
        className="menu__closeTag"
      >
        X
      </span>
      <div>
        <section className="menu__header">
          {userContextData.isLoggedIn && (
            <div className="menu__avatar">
              <Avatar sx={{ width: "6vh", height: "6vh" }}>
                {userContextData.name.toUpperCase().slice(0, 1)}
                {userContextData.surname.toUpperCase().slice(0, 1)}
              </Avatar>
              <p>Hola,</p>
              <p className="username__tag">{userContextData.name}</p>
            </div>
          )}
          {!userContextData.isLoggedIn && "MENÚ"}
        </section>
        <section className="menu__content">
          {location !== "/login" &&
            location !== "/signup" &&
            !userContextData.isLoggedIn && (
              <>
                <Link to="/signup">
                  <div onClick={handleMenuClose} className="menu__item">
                    Crear cuenta
                  </div>
                </Link>
                <hr />
                <Link to="/login" onClick={handleMenuClose}>
                  <div className="menu__item">Iniciar sesión</div>
                </Link>
              </>
            )}
          {location === "/login" && (
            <>
              <Link to="/signup" onClick={handleMenuClose}>
                <div className="menu__item">Crear cuenta</div>
              </Link>
            </>
          )}
          {location === "/signup" && (
            <>
              <Link to="/login" onClick={handleMenuClose}>
                <div className="menu__item">Iniciar sesión</div>
              </Link>
            </>
          )}
          {userType ? (
            <>
              <Link to="/admin/product" onClick={handleMenuClose}>
                <div className="menu__item">Administración</div>
              </Link>
              <Link to="/user/reservations" onClick={handleMenuClose}>
                <div className="menu__item">Mis Reservas</div>
              </Link>
            </>
          ) : (
            <>
              <Link to="/user/reservations" onClick={handleMenuClose}>
                <div className="menu__item">Mis Reservas</div>
              </Link>
            </>
          )}
        </section>
      </div>

      <section className="menu__footer">
        {userContextData.isLoggedIn && (
          <div className="closeSession__message">
            <p>
              ¿Deseas{" "}
              <Link to="/login">
                <span onClick={handleSessionClose}>cerrar sesión</span>
              </Link>
              ?
            </p>
            <hr></hr>
          </div>
        )}
        <div className="menu__contact">
          <OutlineFacebook />
          <OutlineLn />
          <OutlineTwitter />
          <OutlineInstagram />
        </div>
      </section>
    </div>
  );
};

export default Menu;
